import { CuisineCategory } from "apps/user-app/src/app/services/dashboard/dashboard-service";

export class CustomLocalFilters {
    public onlyOpen: boolean = false;
    public cuisineCategories: CuisineCategory[] = [];
}